var map = {
	"./bca.png": "0ec0",
	"./bjb.png": "9742",
	"./bni.png": "f26b",
	"./bri.png": "ce31",
	"./bsi.png": "da09",
	"./cimb.png": "a64e",
	"./logo-bca.png": "ff86",
	"./logo-invoice.png": "aa7a",
	"./logo-mandiri.png": "c481",
	"./logo-qris.png": "c5e2",
	"./logo_pital.png": "6ff1",
	"./mandiri.png": "bade",
	"./permata.png": "3f4f",
	"./qris.png": "b9e1",
	"./toqoo-logo.png": "3066"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d47a";